'use client';

import { useEffect } from 'react';
import { installInAppHistory } from '@/lib/in-app-history';

/**
 * Installs the in-app history depth stamp once, at the root, so every route group — `(app)` and
 * `(public)` alike — is covered. Renders nothing. See `src/lib/in-app-history.ts`.
 */
export function InAppHistoryTracker(): null {
  useEffect(() => {
    installInAppHistory();
  }, []);
  return null;
}
